import { useLayoutEffect, useRef, useState } from "react";

import PortalIE from "./PortalIE";

/** Painel flutuante que abre no hover do trigger, renderizado via portal em
 * document.body e posicionado a partir da posição real do trigger na viewport
 * (position: fixed) — assim ele nunca é cortado por um ancestral com scroll
 * (ex.: o wrapper overflow-x-auto das tabelas de ranking, cujo overflow-x
 * força overflow-y a virar "auto" também, cortando qualquer coisa que vaze
 * verticalmente da célula). A direção (acima/abaixo) é decidida pelo espaço
 * real disponível na viewport, não por um índice de linha fixo. */
export function HoverPopover({ trigger, children, width = 256 }) {
  const anchorRef = useRef(null);
  const panelRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ left: 0, top: 0, ready: false });

  useLayoutEffect(() => {
    if (!open) return;
    const anchor = anchorRef.current;
    const panel = panelRef.current;
    if (!anchor || !panel) return;

    const gap = 8;
    const rect = anchor.getBoundingClientRect();
    const panelH = panel.offsetHeight;
    const spaceBelow = window.innerHeight - rect.bottom;
    const top =
      spaceBelow >= panelH + gap ? rect.bottom + gap : rect.top - gap - panelH;

    let left = rect.right - width;
    left = Math.max(8, Math.min(left, window.innerWidth - width - 8));

    setPos({ left, top: Math.max(8, top), ready: true });
  }, [open, width]);

  function fechar() {
    setOpen(false);
    setPos(p => ({ ...p, ready: false }));
  }

  return (
    <span
      ref={anchorRef}
      className="relative inline-flex"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={fechar}
    >
      {trigger}
      {open && (
        <PortalIE>
          <span
            ref={panelRef}
            className="block overflow-hidden rounded-xl border border-[var(--color-brand)]/30 bg-[var(--color-surface)] text-left shadow-[var(--shadow-card-hover)]"
            style={{
              // position/zIndex inline: `z-50` do original vale 50, abaixo do
              // sidebar (1032) e do header (1029) do AVA — o popover apareceria
              // atrás deles. 1036 fica acima do drawer (1035) e ainda abaixo do
              // modal-backdrop do Bootstrap (1040).
              position: "fixed",
              zIndex: 1036,
              pointerEvents: "none",
              width,
              left: pos.left,
              top: pos.top,
              visibility: pos.ready ? "visible" : "hidden"
            }}
          >
            {children}
          </span>
        </PortalIE>
      )}
    </span>
  );
}
